interface ShiftCanvasLogoProps {
  variant?: "text" | "text-small" | "icon";
  className?: string;
  alt?: string;
  "data-testid"?: string;
}

const logoMap = {
  text: { light: "/images/shiftcanvas-logo-text.png", dark: "/images/shiftcanvas-logo-text-dark.png" },
  "text-small": { light: "/images/shiftcanvas-logo-text-small.png", dark: "/images/shiftcanvas-logo-text-small-dark.png" },
  icon: { light: "/images/shiftcanvas-logo-icon.png", dark: "/images/shiftcanvas-logo-icon-dark.png" },
};

export function ShiftCanvasLogo({ variant = "text", className = "", alt = "ShiftCanvas", ...props }: ShiftCanvasLogoProps) {
  const { light, dark } = logoMap[variant];

  return (
    <>
      <img src={light} alt={alt} className={`dark:hidden ${className}`} data-testid={props["data-testid"]} />
      <img src={dark} alt={alt} className={`hidden dark:block ${className}`} data-testid={props["data-testid"]} />
    </>
  );
}
